import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name1', id: 22, type: 1 },
    children: [
      {
        path: '',  // 默认子路由，访问/时显示该页面
        name: 'souye',
        component: () => import('@/views/souye/souye.vue'),
        meta: { titleKey: 'directory.name1', id: 22 }
      }
    ]
  },
  {
    path: '/about',
    name: 'about',
    redirect: '/about/about', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name2', id: 1, type: 1 },
    children: [
      {
        path: '/about/about',  // 默认子路由，访问/时显示该页面
        name: '/about/about',
        component: () => import('@/views/gybo/about.vue'),
        meta: { title: 'directory.name11', id: 134 }
      },
      {
        path: '/about/qywh',  // 默认子路由，访问/时显示该页面
        name: '/about/qywh',
        component: () => import('@/views/gybo/qywh.vue'),
        meta: { title: 'directory.name12', id: 132 }
      },
      {
        path: '/about/qyry',  // 默认子路由，访问/时显示该页面
        name: '/about/qyry',
        component: () => import('@/views/gybo/qyry.vue'),
        meta: { title: 'directory.name13', id: 4 }
      },
      {
        path: '/about/fwwd',  // 默认子路由，访问/时显示该页面
        name: '/about/fwwd',
        component: () => import('@/views/gybo/fwwd.vue'),
        meta: { title: 'directory.name14', id: 131 }
      },
      {
        path: '/about/xcsp',  // 默认子路由，访问/时显示该页面
        name: '/about/xcsp',
        component: () => import('@/views/gybo/xcsp.vue'),
        meta: { title: 'directory.name15', id: 24 }
      },
    ]
  },
  {
    path: '/xwzx',
    name: 'xwzx',
    redirect: '/xwzx/gsxw', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name3', id: 2, type: 1 },
    children: [
      {
        path: '/xwzx/gsxw',  // 默认子路由，访问/时显示该页面
        name: '/xwzx/gsxw',
        component: () => import('@/views/xwzx/gsxw.vue'),
        meta: { title: 'directory.name16', id: 10 }
      },
      {
        path: '/xwzx/hyxw',  // 默认子路由，访问/时显示该页面
        name: '/xwzx/hyxw',
        component: () => import('@/views/xwzx/hyxw.vue'),
        meta: { title: 'directory.name17', id: 9 }
      },
      {
        path: '/xwzx/mtbd',  // 默认子路由，访问/时显示该页面
        name: '/xwzx/mtbd',
        component: () => import('@/views/xwzx/mtbd.vue'),
        meta: { title: 'directory.name18', id: 8 }
      },
      {
        path: '/xwzx/xwxq',  // 默认子路由，访问/时显示该页面
        name: '/xwzx/xwxq',
        component: () => import('@/views/xwzx/xwxq.vue'),
        meta: { title: '', type: -1, }//type为-1的不渲染到目录上
      },
    ]
  },
  {
    path: '/cpsb',
    name: 'cpsb',
    redirect: '/cpsb/gjzf', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name4', id: 11, type: 1 },
    children: [
      {
        path: '/cpsb/gjzf',  // 默认子路由，访问/时显示该页面
        name: '/cpsb/gjzf',
        component: () => import('@/views/cpsb/gjzf.vue'),
        meta: { title: 'directory.name19', id: 14 }
      },
      {
        path: '/cpsb/llsb',  // 默认子路由，访问/时显示该页面
        name: '/cpsb/llsb',
        component: () => import('@/views/cpsb/llsb.vue'),
        meta: { title: 'directory.name20', id: 13 }
      },
      {
        path: '/cpsb/qtcll',  // 默认子路由，访问/时显示该页面
        name: '/cpsb/qtcll',
        component: () => import('@/views/cpsb/qtcll.vue'),
        meta: { title: 'directory.name21', id: 12 }
      },
      {
        path: '/cpsb/bzxt',  // 默认子路由，访问/时显示该页面
        name: '/cpsb/bzxt',
        component: () => import('@/views/cpsb/bzxt.vue'),
        meta: { title: 'directory.name22', id: 25 }
      },
      {
        path: '/cpsb/xqxx',  // 默认子路由，访问/时显示该页面
        name: '/cpsb/xqxx',
        component: () => import('@/views/cpsb/xqxx.vue'),
        meta: { title: '', type: -1, }//type为-1的不渲染到目录上
      },
    ]
  },
  {
    path: '/yzxm',
    name: 'yzxm',
    redirect: '/yzxm/yzxm', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name5', id: 26, type: 1 },
    children: [
      {
        path: '/yzxm/yzxm',  // 默认子路由，访问/时显示该页面
        name: '/yzxm/yzxm',
        component: () => import('@/views/yzxm/yzxm.vue'),
        meta: { title: 'directory.name5', id: 26 }
      },
      {
        path: '/yzxm/xmxq',  // 默认子路由，访问/时显示该页面
        name: '/yzxm/xmxq',
        component: () => import('@/views/yzxm/xmxq.vue'),
        meta: { title: '', type: -1, }//type为-1的不渲染到目录上
      },
    ]
  },
  {
    path: '/gylc',
    name: 'gylc',
    redirect: '/gylc/sxll', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name6', id: 27, type: 1 },
    children: [
      {
        path: '/gylc/sxll',  // 默认子路由，访问/时显示该页面
        name: '/gylc/sxll',
        component: () => import('@/views/gylc/sxll.vue'),
        meta: { title: 'directory.name23', id: 166 }
      },
      {
        path: '/gylc/yls',  // 默认子路由，访问/时显示该页面
        name: '/gylc/yls',
        component: () => import('@/views/gylc/yls.vue'),
        meta: { title: 'directory.name24', id: 167 }
      },
      {
        path: '/gylc/gy',  // 默认子路由，访问/时显示该页面
        name: '/gylc/gy',
        component: () => import('@/views/gylc/gy.vue'),
        meta: { title: 'directory.name25', id: 168 }
      },
    ]
  },
  {
    path: '/epc',
    name: 'epc',
    redirect: '/epc/epc', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name7', id: 31, type: 1 },
    children: [
      {
        path: '/epc/epc',  // 默认子路由，访问/时显示该页面
        name: '/epc/epc',
        component: () => import('@/views/epc/epc.vue'),
        meta: { title: 'directory.name7', id: 31 }
      },
      {
        path: '/epc/epcxq',  // 默认子路由，访问/时显示该页面
        name: '/epc/epcxq',
        component: () => import('@/views/epc/epcxq.vue'),
        meta: { title: '', type: -1, }//type为-1的不渲染到目录上
      },
    ]
  },
  {
    path: '/rczp',
    name: 'rczp',
    redirect: '/', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name8', id: 32, type: 1 },
    children: []
  },
  {
    path: '/bzdj',
    name: 'bzdj',
    redirect: '/', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name9', id: 33, type: 1 },
    children: []
  },
  {
    path: '/lxwm',
    name: 'lxwm',
    redirect: '/lxwm/lxfs', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'directory.name10', id: 36, type: 1 },
    children: [
      {
        path: '/lxwm/lxfs',  // 默认子路由，访问/时显示该页面
        name: '/lxwm/lxfs',
        component: () => import('@/views/lxwm/lxfs.vue'),
        meta: { title: 'directory.name26', id: 36 }
      },
      {
        path: '/lxwm/zxly',  // 默认子路由，访问/时显示该页面
        name: '/lxwm/zxly',
        component: () => import('@/views/lxwm/lxfs.vue'),
        meta: { title: 'directory.name27', id: 36 }
      },
    ]
  },
  {
    path: '/zscq',
    name: 'zscq',
    redirect: '/', // 自动重定向到默认子路由
    component: () => import('@/views/Home.vue'),
    meta: { },
    children: [
      {
        path: '/zscq/zscq',  // 默认子路由，访问/时显示该页面
        name: '/zscq/zscq',
        component: () => import('@/views/zscq/zscq.vue'),
        meta: {  }
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 配置滚动行为
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则恢复到该位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到页面顶部
    return { top: 0, behavior: 'smooth' }
  }
})

export default router